var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 27C24.0005 24.8783 23.1575 22.8434 21.6571 21.3431C20.1567 19.8429 18.1217 19 15.9997 19M15.9997 19C13.8778 19 11.8428 19.8429 10.3424 21.3431C8.84195 22.8434 7.99902 24.8783 7.99902 27M15.9997 19C18.7614 19 21.0002 16.7614 21.0002 14C21.0002 11.2386 18.7614 9 15.9997 9C13.2381 9 10.9993 11.2386 10.9993 14C10.9993 16.7614 13.2381 19 15.9997 19ZM28.0006 26.0002C28.0006 22.6302 26.0004 19.5002 24.0003 18.0002C24.6577 17.507 25.1835 16.8593 25.531 16.1145C25.8785 15.3696 26.037 14.5507 25.9925 13.73C25.948 12.9093 25.7018 12.1123 25.2759 11.4094C24.8499 10.7065 24.2572 10.1195 23.5502 9.7002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignTeam);
export default __webpack_public_path__ + "static/media/alignTeam.88c89a4f6550eb04013af243cb820668.svg";
export { ForwardRef as ReactComponent };